import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BadgeCenterState {
    cart: number;
    orders: number;
    messages: number;
    notifications: number;
    finance: number;
}

const initialState: BadgeCenterState = {
    cart: 0,
    orders: 0,
    messages: 0,
    notifications: 0,
    finance: 0,
};

const badgeCenterSlice = createSlice({
    name: "badgeCenter",
    initialState,
    reducers: {
        setCartBadge: (state, action: PayloadAction<number>) => {
            state.cart = action.payload;
        },
        setOrdersBadge: (state, action: PayloadAction<number>) => {
            state.orders = action.payload;
        },
        setMessagesBadge: (state, action: PayloadAction<number>) => {
            state.messages = action.payload;
        },
        incrementMessagesBadge: (state) => {
            state.messages += 1;
        },
        setFinanceBadge: (state, action: PayloadAction<number>) => {
            state.finance = action.payload;
        },
    },
});

export const {
    setCartBadge,
    setOrdersBadge,
    setMessagesBadge,
    incrementMessagesBadge,
    setFinanceBadge,
} = badgeCenterSlice.actions;

export default badgeCenterSlice.reducer;
